import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, signal, ViewEncapsulation } from '@angular/core';
import { CellRenderer, Column } from './cell-renderer';

@Component({
  selector: 'cbre-data-column-renderer, [cbreDataColumnRenderer]',
  template: ` {{ value }} &nbsp; `,
  imports: [CommonModule],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultColumnRendererComponent<T = Record<string, any>> implements CellRenderer<Column> {
  // convert data and config in getter and setters so we can call setValue every time they changes
  // change data and config getter to a signal to Angular that the value has changed

  @Input() set data(data: T) {
    this._data.set(data ?? ({} as T));
    this.setValue();
  }

  @Input() set config(config: Column) {
    this._config.set(config);
    this.setValue();
  }
  public value = null;

  private _data = signal<T>({} as T);
  private _config = signal<Column>(null);

  private setValue() {
    const data = this._data();
    const config = this._config();
    if (config?.displayFn != null) {
      this.value = config.displayFn(data);
    } else {
      this.value = data[config?.path || config?.field];
    }
  }

  render(): void {
    // required by CellRenderer
  }
}
